<template>
    <div class="a-input-text input-text-wrapper">
        <input
            v-model="localValue"
            v-mask="mask"
            :id="elementId"
            :type="inputType"
            :class="inputClassList"
            :disabled="isDisabled"
            :placeholder="placeholder"
            :readonly="isReadOnly"
            :autocomplete="inputAutocomplete"
            :at-a-input-text="atAttribute"
            :inputmode="inputmode"
            class="input-text"
            @paste="handlePaste"
            @keypress="handleKeypress"
            @blur="handleBlur"
        />
        <div
            v-if="isHiddenValue"
            class="input-text-hidden-value-overlay"
        >
            {{ transformedValue }}
        </div>
    </div>

</template>

<script>

export default {
    name: 'AInputText',
    props: {
        /**
         * Set id attribute
         */
        elementId: {
            type: String,
            default: null
        },
        /**
         * Set type for input field
         */
        type: {
            type: String,
            validator: val => ['text', 'tel'].includes(val),
            default: 'text'
        },
        /**
         * Set additional list of classes
         */
        classList: {
            type: String,
            default: ''
        },
        /**
         * Set disabled attribute
         */
        isDisabled: {
            type: Boolean,
            default: false
        },
        /**
         * Set readonly attribute
         */
        isReadOnly: {
            type: Boolean,
            default: false
        },
        /**
         * Set placeholder for input
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * Set input value
         */
        value: {
            type: String,
            default: ''
        },
        /**
         * Locator for automating tests
         */
        atAttribute: {
            type: String,
            default: ''
        },
        /**
         * Set an autocomplete attribute
         */
        isAutoComplete: {
            type: Boolean,
            default: true
        },
        /**
         * Set mask rules
         */
        mask: {
            type: String,
            default: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
        },
        /**
         * Set mask rules
         */
        allowedCharacters: {
            type: [String, RegExp],
            default: ''
        },
        /**
         * Should be hidden input value and show transformed value
         */
        isHiddenValue: {
            type: Boolean,
            default: false
        },
        /**
         * Set keyboard type for mobile/tables devices
         */
        inputmode: {
            type: String,
            validator: val => ['none', 'text', 'decimal', 'numeric', 'tel', 'search', 'email', 'url'].includes(val),
            default: 'text'
        }
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        transformedValue() {
            return this.localValue.replace(/./g, '*')
        },
        inputClassList() {
            const classList = [];
            if(this.isDisabled) {
                classList.push('input-text--disabled');
            }
            if(this.isHiddenValue) {
                classList.push('input-text--hidden-value');
            }
            if(this.classList) {
                classList.push(this.classList);
            }
            return classList;
        },
        inputType() {
            return this.type;
        },
        inputAutocomplete() {
            return this.isAutoComplete ? 'on' : 'new-password'
        }
    },
    methods: {
        handleBlur(e) {
            this.$emit('blur', e);
        },
        handleKeypress(e) {
            if (!this.allowedCharacters) return;
            if (!e.key.match(this.allowedCharacters)) {
                e.preventDefault();
            }
        },
        handlePaste(e) {
            if (!this.allowedCharacters) return;
            if (!(e.clipboardData || window.clipboardData).getData('text').match(this.allowedCharacters)) {
                e.preventDefault();
            }
        },
    }
};
</script>

<style lang="scss">
    @import 'theme';
</style>
